import React, { useRef, useEffect, useState } from 'react'
import { MASTERMULTICINEMA, MASTERMULTITOTAL } from '../../constants/multiCinemaModes'
import Translation from '../Translation/cont/Translation'

const lockSvg = (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path fill="#ffffff" d="M289.9,321.16c0-18.73-15.18-33.91-33.91-33.91c-18.72,0-33.9,15.18-33.9,33.91c0,11.6,5.84,21.84,14.73,27.95v41.75c0,0,0,17.09,17.09,17.09h4.17c0,0,17.09,0,17.09-17.09v-41.75C284.06,343,289.9,332.77,289.9,321.16 M428.72,452.87c0,26.36-23.47,28.03-28.09,28.09H111.37c-26.35,0-28.03-23.47-28.09-28.09V242.33c0-26.3,23.39-28.02,28.15-28.09h289.2c26.35,0,28.03,23.47,28.09,28.09V452.87z M453.81,452.87V242.33c0-21.37-14.16-53.18-53.18-53.18H152.6l-11.97-27.22c-1.33-3.09-31.39-76.11,63.14-117.7c94.52-41.57,128.05,29.9,129.47,33.04l24.87,54.83c2.86,6.3,10.3,9.11,16.6,6.24c6.31-2.86,9.1-10.29,6.24-16.6l-24.82-54.7c-0.42-0.99-44.58-97.63-162.47-45.76c-60.94,26.81-78.54,66.24-82.57,94.58c-4.38,30.81,6.11,55.1,6.55,56.12l7.55,17.16h-13.82c-21.37,0-53.18,14.17-53.18,53.18v210.54c0,21.38,14.16,53.18,53.18,53.18h289.26C422,506.05,453.81,491.89,453.81,452.87"/>
    </svg>
)

const icons = {
    programm: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.44 29.99"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><path className="hx-cls-1" d="M25.94,0V2.11H21.37V0h-1.5V4.8H7.57V0H6.07V2.11H1.5V0H0V30H1.5V28.48H6.07V30h1.5V24.16h12.3V30h1.5V28.48h4.57V30h1.5V0ZM21.37,11.9h4.57v6.79H21.37Zm4.57-8.29V10.4H21.37V3.61ZM1.5,11.9H6.07v6.79H1.5ZM6.07,3.61V10.4H1.5V3.61ZM1.5,27V20.19H6.07V27Zm6.07-4.32V6.3h12.3V22.66ZM21.37,27V20.19h4.57V27Z"/></svg>
    ),
    advertisement: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.59 30.15"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><g className="hx-cls-1" id="Ebene_2" data-name="Ebene 2"><g id="Ebene_2-2" data-name="Ebene 2"><rect x="6.45" y="20.08" width="1.5" height="1.5" transform="translate(-12.62 11.19) rotate(-45)"/><path d="M17.72,27.18c.17-1.75-.48-2.39-.54-2.43l-.86-.87a3,3,0,0,0,.52-1.73,4.19,4.19,0,0,0-1.09-2.5l.48-.47.19-.2,11.17-6.67L23.32,8.05a3.16,3.16,0,0,0,.57-1.67,2.54,2.54,0,0,0-.79-1.81A2.53,2.53,0,0,0,20.24,4a3.47,3.47,0,0,0-.64.34L15.27,0,8.57,11.35l-.08.09-.62.61L1.6,18.33l-.85.85-.21.21,1.4,1.4L0,22.72l.54.54.52.52,2.79,2.79.56.56.5.5L6.85,25.7l1.43,1.43.21-.21.85-.85,1-1,5.07,5.07.5-.33A3.56,3.56,0,0,0,17.72,27.18ZM14.87,21a2.28,2.28,0,0,1,.47,1.23,1.53,1.53,0,0,1-.12.6L14.13,21.7ZM22,5.63a1,1,0,0,1,.34.73,1.32,1.32,0,0,1-.15.59L20.68,5.41A1.13,1.13,0,0,1,22,5.63Zm-3.57-.31h0l3.84,3.84h0L25.17,12,15.64,17.7,9.93,12l5.65-9.57ZM4.91,25.51,2.12,22.72,3,21.85l2.79,2.79ZM2.66,19.39l6.27-6.27,3.13,3.13L8.91,19.39,10,20.45l3.15-3.14,1.43,1.43L8.28,25Zm8.93,4.85,1.48-1.48L15.31,25l.82.82s.2.2.1,1.22a1.83,1.83,0,0,1-.67,1.16Z"/></g></g></svg>
    ),
    web2print: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><path className="hx-cls-1" d="M0,6V18.24H4.38V28.5h0V30h15.7l.13-.13h0l5.22-5.22h0v-1.5h0V15H27V13.5H2.81V15H4.38v1.74H1.5V7.45h27v9.29H25.43v1.5H30V6Zm23.31,18.7-3.23,3.23V24.65ZM23.93,15v8.15H18.58V28.5H5.88V15Z"/><polygon className="hx-cls-1" points="5.88 1.5 23.93 1.5 23.93 4.85 25.43 4.85 25.43 1.5 25.43 0 23.93 0 5.88 0 4.38 0 4.38 1.5 4.38 4.85 5.88 4.85 5.88 1.5"/><rect className="hx-cls-1" x="23.93" y="8.2" width="3.08" height="1.5"/><rect className="hx-cls-1" x="23.93" y="10.66" width="3.08" height="1.5"/></svg>
    ),
    signage: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.78 30"><defs><style>{'.hx-d{fill:#fff}'}</style></defs><rect className="hx-d" x="17.28" width="1.5" height="30"/><rect className="hx-d" width="1.5" height="30"/><rect className="hx-d" y="28.5" width="18.78" height="1.5"/><rect className="hx-d" x=".34" y="25.44" width="17.67" height="1.5"/><rect className="hx-d" x=".34" width="17.67" height="1.5"/><rect className="hx-d" x="5.49" y="16.63" width="9.95" height="1.5"/><rect className="hx-d" x="5.49" y="18.92" width="9.95" height="1.5"/><rect className="hx-d" x="5.49" y="21.17" width="9.95" height="1.5"/><rect className="hx-d" x="3.34" y="16.63" width="1.5" height="1.5"/><rect className="hx-d" x="3.34" y="18.92" width="1.5" height="1.5"/><rect className="hx-d" x="3.34" y="21.17" width="1.5" height="1.5"/><path className="hx-d" d="M9.39,15.15c-3.25,0-5.89-2.64-5.89-5.89S6.15,3.38,9.39,3.38s5.89,2.64,5.89,5.89-2.64,5.89-5.89,5.89Zm0-10.27c-2.42,0-4.39,1.97-4.39,4.39s1.97,4.39,4.39,4.39,4.39-1.97,4.39-4.39-1.97-4.39-4.39-4.39Z"/><polygon className="hx-d" points="10.87 11.48 8.64 9.62 8.64 5.98 10.14 5.98 10.14 8.92 11.83 10.33 10.87 11.48"/></svg>
    ),
    apps: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.8 30"><style>{'.hx-st0{fill:#fff}'}</style><path className="hx-st0" d="M0,0v30h18.8V0H0z M17.2,28.5H1.6v-27h15.6V28.5z"/><path className="hx-st0" d="M7.6,4.5h3.5c0.4,0,0.8-0.3,0.8-0.8S11.5,3,11.1,3H7.6C7.2,3,6.9,3.3,6.9,3.8S7.2,4.5,7.6,4.5z"/><circle className="hx-st0" cx="9.4" cy="25.5" r="1.4"/></svg>
    ),
    newsletter: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.33 59.26"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><rect className="hx-cls-1" x="18.14" y="29.21" width="23.05" height="2.93"/><rect className="hx-cls-1" x="18.15" y="14.61" width="23.05" height="2.93"/><rect className="hx-cls-1" x="18.14" y="21.92" width="23.05" height="2.93"/><path className="hx-cls-1" d="M59.09,20.81s-2.97-2.73-6.98-6.14V5.72h-11.28C35.48,1.87,31.83,0,29.67,0s-5.82,1.87-11.17,5.73H7.28v8.88C3.26,18.04.27,20.78.24,20.81l-.24.22v38.23h59.33V21.03l-.24-.22ZM35.65,5.72h-11.97c3.74-2.4,5.34-2.8,5.99-2.8s2.24.4,5.98,2.8ZM56.4,56.33H2.93V22.51c.71-.66,2.89-2.66,4.39-4v14.94l.27.22c1.82,1.46,17.88,14.3,22.09,14.3s20.34-12.96,22.16-14.44l.27-.22v-14.79c1.46,1.31,3.59,3.29,4.29,3.94v33.88ZM49.19,31.96c-9.75,8.2-17.04,13.09-19.52,13.09s-9.73-4.86-19.43-13.02V8.65h38.95v23.31Z"/></svg>
    ),
    elbenwald: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.19 60"><defs><style>{'.hx-cls-1{fill:#fff;stroke-width:0px}'}</style></defs><path className="hx-cls-1" d="M41.7,47.4l-2.7-.8-4.3,8.1H15.7v-23h14.3l2,6.5h3.1v-17.8h-3.1l-2,5.9h-14.3V5.2h18.3l2.3,7.8h3V0H0v2.7l8,2.5v49.5l-8,2.4v2.8h39.4l2.3-12.5h0ZM68.93,11.48c0-6.1-4.9-11.1-11-11.1s-11,4.9-11,11.1,4.9,11,11,11,11-4.9,11-11h0ZM66.53,11.48c0,5.1-3.4,9.1-8.6,9.1s-8.6-3.9-8.6-9.1,3.5-9.1,8.6-9.1,8.6,3.9,8.6,9.1h0ZM64.13,17.68v-.8l-1.8-.5-2.8-4.6c.9-.3,2.2-1.5,2.2-3.4s-1.3-3.5-4.1-3.5h-4.7v.8l1.7.5v10.2l-1.7.5v.8h5.2v-.8l-1.7-.5v-4.3l1.1-.1,3.1,5.6,3.5.1h0ZM59.93,8.48c0,1.5-.9,2.3-2.1,2.3h-1.1v-4.7h1.1c1.4,0,2.1,1.1,2.1,2.4h0Z"/></svg>
    ),
    chatbot: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><path className="hx-cls-1" d="M28.5,1.5H1.5A1.5,1.5,0,0,0,0,3V20a1.5,1.5,0,0,0,1.5,1.5H12l3,5,3-5H28.5A1.5,1.5,0,0,0,30,20V3A1.5,1.5,0,0,0,28.5,1.5Zm0,18.5H1.5V3H28.5Z"/><circle className="hx-cls-1" cx="9" cy="12" r="2"/><circle className="hx-cls-1" cx="15" cy="12" r="2"/><circle className="hx-cls-1" cx="21" cy="12" r="2"/><rect className="hx-cls-1" x="13.25" y="0" width="1.5" height="3"/><circle className="hx-cls-1" cx="14" cy="0.75" r="1.5"/></svg>
    ),
    socialmedia: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.36 59.21"><defs><style>{'.hx-cls-1{fill:#fff}'}</style></defs><polygon className="hx-cls-1" points="24.64 2.12 24.64 18.73 27.59 18.73 27.59 5.07 59.42 5.07 59.42 36.84 53.59 36.84 46.85 42.37 46.89 36.84 31.17 36.84 31.17 39.78 43.93 39.78 43.85 48.63 54.65 39.78 62.36 39.78 62.36 2.12 24.64 2.12"/><path className="hx-cls-1" d="M30.11,19.91H0v30.06h7.71l9.7,7.96-.06-7.96h12.76v-30.06ZM14.41,51.67l-5.66-4.65H2.94v-24.18h24.23v24.18h-12.79l.03,4.65Z"/><path className="hx-cls-1" d="M53.12,18.74c-.56-.63-1.35-1-2.1-1l-2.51-.03.49-2.04c.27-1.35-.21-3.23-4.01-4.58l-1.55-.55-2.35,6.68c-.19-.05-.39-.08-.59-.08h-2.58c-1.3,0-2.35,1.05-2.35,2.35v9.58c0,1.3,1.05,2.35,2.35,2.35h2.63c.69,0,1.33-.3,1.8-.85h7.74c1.4,0,2.87-1.43,2.87-2.71l.88-7.02c.09-.75-.15-1.49-.69-2.1ZM40.15,19.77v9h-1.96v-9h1.96ZM51.21,20.52l-.87,7.09c-.03.1-.22.29-.26.32h-7.2v-7.87l2.15-6.11c1.01.48,1.44.93,1.39,1.16l-1.23,5.19,5.8.08s.11.05.22.14Z"/><path className="hx-cls-1" d="M17.72,28.57c-1.21,0-2.36.47-3.23,1.31-.85-.84-2.01-1.31-3.24-1.31-2.57,0-4.66,2.09-4.66,4.66,0,3.18,2.39,5.03,4.14,6.39,1.22.94,2.27,1.76,2.34,2.63l.05.58h2.73l.05-.58c.07-.87,1.12-1.68,2.33-2.62h0c1.75-1.35,4.15-3.2,4.15-6.4,0-2.57-2.09-4.66-4.66-4.66ZM19.56,33.22c0,1.77-1.4,2.86-3.08,4.17-.65.5-1.38,1.06-1.98,1.7-.61-.65-1.35-1.22-2.02-1.74-1.63-1.26-3.04-2.34-3.04-4.13,0-1,.81-1.81,1.84-1.81.95,0,1.75.74,1.81,1.69l.04.59h2.78l.04-.59c.06-.95.85-1.69,1.81-1.69,1,0,1.81.81,1.81,1.81Z"/></svg>
    ),
    events: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><style>{'.hx-st0{fill:#fff}'}</style><path className="hx-st0" d="M28.5,3.2h-3.8V0h-1.5v3.2H6.3V0H4.8v3.2H0v26.8h30V3.2H28.5zM28.5,28.4h-27V9.9h27V28.4zM28.5,8.4h-27V4.7h27V8.4z"/><path className="hx-st0" d="M25.4,16.3h-8.9v8.9h8.9V16.3zM23.9,23.7H18v-5.9h5.9V23.7z"/></svg>
    ),
    cinemas: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.979 28.5"><defs><style>{'.hx-a{fill:#fff}'}</style></defs><path className="hx-a" d="M254.427,293.327s4.891-5.727,5.13-6.2a6.653,6.653,0,0,0,1.074-3.282c0-1.61-.865-6.383-6.383-6.383s-6.131,5.1-6.145,6.085a7.258,7.258,0,0,0,.959,3.573A73.576,73.576,0,0,0,254.427,293.327Zm-.03-12.737a3.1,3.1,0,1,1-3.1,3.1A3.1,3.1,0,0,1,254.4,280.59Z" transform="translate(-239.803 -277.458)"/><path className="hx-a" d="M260.516,287.164l-.822,1.193,7.392,3.563-5.253,4.1-4.89-4.313-.315.357,4.775,4.213-7.258,3.033-8.449-10.57h3.363l-.827-1.432h-3.669l-4.76,3.254,10.474,15.391,4.485-5.438,7.655-3.107,7.365-5.783Zm-10.129,16.411-8.6-12.628,3.235-2.2h.061l8.637,10.806Z" transform="translate(-239.803 -277.458)"/></svg>
    ),
}

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

const HexTile = ({ labelId, label, descId, iconKey, disabled, calloutDir, onClick }) => {
    const wrapRef = useRef(null)
    const [denied, setDenied] = useState(false)

    useEffect(() => {
        const el = wrapRef.current
        if (!el || prefersReducedMotion()) return undefined

        const handleMove = (event) => {
            const rect = el.getBoundingClientRect()
            const px = (event.clientX - rect.left) / rect.width
            const py = (event.clientY - rect.top) / rect.height
            const amp = disabled ? 4 : 9
            el.style.setProperty('--mx', (px * 100).toFixed(1) + '%')
            el.style.setProperty('--my', (py * 100).toFixed(1) + '%')
            el.style.setProperty('--ry', ((px - 0.5) * amp).toFixed(2) + 'deg')
            el.style.setProperty('--rx', (-(py - 0.5) * amp).toFixed(2) + 'deg')
        }

        const handleEnter = () => {
            el.style.setProperty('--sc', disabled ? '0.93' : '1.02')
            el.style.setProperty('--ty', disabled ? '-2px' : '-6px')
        }

        const resetTransform = () => {
            el.style.setProperty('--sc', 'var(--hex-rest-scale)')
            el.style.setProperty('--ty', '0px')
            el.style.setProperty('--rx', '0deg')
            el.style.setProperty('--ry', '0deg')
            el.style.setProperty('--mx', '50%')
            el.style.setProperty('--my', '50%')
        }

        el.addEventListener('mousemove', handleMove)
        el.addEventListener('mouseenter', handleEnter)
        el.addEventListener('mouseleave', resetTransform)

        return () => {
            el.removeEventListener('mousemove', handleMove)
            el.removeEventListener('mouseenter', handleEnter)
            el.removeEventListener('mouseleave', resetTransform)
        }
    }, [disabled])

    const handleClick = () => {
        if (disabled) {
            setDenied(false)
            requestAnimationFrame(() => setDenied(true))
            return
        }
        onClick()
    }

    const status = disabled
        ? <Translation id="dashboard_hex_status_locked">Locked</Translation>
        : <Translation id="dashboard_hex_status_active">Active</Translation>

    return (
        <button
            type="button"
            ref={wrapRef}
            className={`db-hex-wrap${disabled ? ' db-hex-wrap--disabled' : ''}${denied ? ' db-hex-wrap--denied' : ''}`}
            onClick={handleClick}
            onAnimationEnd={() => setDenied(false)}
            aria-disabled={disabled}
        >
            {disabled && <span className="db-hex-lock" aria-hidden="true">{lockSvg}</span>}
            <span className="db-hex-ring" aria-hidden="true" />
            <span className="db-hex-gap" aria-hidden="true" />
            <span className="db-hex-border" aria-hidden="true" />
            <span className="db-hex-fill" aria-hidden="true" />
            <span className="db-hex-glow" aria-hidden="true" />
            <span className="db-hex-body" aria-hidden="true">
                <span className="db-hex-icon">{icons[iconKey]}</span>
                <span className="db-hex-lbl"><Translation id={labelId}>{label}</Translation></span>
            </span>

            <span className={`db-hex-callout db-hex-callout--${calloutDir}`} aria-hidden="true">
                <span className="db-hex-callout-node" />
                <span className="db-hex-callout-lead" />
                <span className="db-hex-callout-panel">
                    <span className="db-hex-callout-kicker"><Translation id="dashboard_hex_kicker">Module</Translation></span>
                    <span className="db-hex-callout-head">
                        <span className="db-hex-callout-ico">{icons[iconKey]}</span>
                        <span className="db-hex-callout-title"><Translation id={labelId}>{label}</Translation></span>
                    </span>
                    <span className="db-hex-callout-divider" />
                    <span className="db-hex-callout-desc"><Translation id={descId} /></span>
                    <span className={`db-hex-callout-status${disabled ? ' db-hex-callout-status--locked' : ''}`}>{status}</span>
                </span>
            </span>
        </button>
    )
}

// ─── Responsive wrap: how many hexes fit per (non-offset) row at a given width
const HEX_MIN  = 120
const HEX_MAX  = 350
const HEX_GAP  = 4
const COL_BREAKPOINTS = [
    { min: 1180, cols: 6 },
    { min: 980,  cols: 5 },
    { min: 780,  cols: 4 },
    { min: 560,  cols: 3 },
    { min: 360,  cols: 2 },
    { min: 0,    cols: 1 },
]

const colsForWidth = (width) => (COL_BREAKPOINTS.find(bp => width >= bp.min) || COL_BREAKPOINTS[COL_BREAKPOINTS.length - 1]).cols

const hexWidthFor = (width, cols) => {
    const raw = (width - HEX_GAP * (cols - 1)) / cols
    return Math.min(HEX_MAX, Math.max(HEX_MIN, raw))
}

// Alternating honeycomb rows: even rows get `cols` tiles, odd (offset) rows get `cols - 1`.
const chunkIntoRows = (tiles, cols) => {
    if (cols <= 1) return tiles.map(tile => [tile])

    const rows = []
    let i = 0
    let rowIndex = 0
    while (i < tiles.length) {
        const rowLen = rowIndex % 2 === 0 ? cols : Math.max(1, cols - 1)
        rows.push(tiles.slice(i, i + rowLen))
        i += rowLen
        rowIndex++
    }
    return rows
}

class DashboardHexMenu extends React.Component {
    constructor(props) {
        super(props)
        this.sectionRef = React.createRef()
        this.state = { hexW: 210, cols: 6 }
    }

    componentDidMount() {
        this.observer = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width
            const cols = colsForWidth(width)
            const hexW = hexWidthFor(width, cols)
            this.setState(prev => (prev.cols === cols && prev.hexW === hexW ? null : { cols, hexW }))
        })
        this.observer.observe(this.sectionRef.current)
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect()
    }

    nav(path) {
        this.props.history.push(path)
    }

    render() {
        const { routes, routeData, multiCinemaMode, hasNewsletter, hasChatbot, hasSocialMedia } = this.props
        const { hexW, cols } = this.state

        const isOn = key => routeData[key] === true || routeData[key] === 'true'

        const hasSignage    = isOn('signage') || isOn('signagelite')
        const hasApps       = isOn('apps')
        const hasEvents     = isOn('events')
        const hasElbenwald  = isOn('elbenwald')
        const showCinemas   = multiCinemaMode === MASTERMULTICINEMA || multiCinemaMode === MASTERMULTITOTAL

        const printPath = routes.webtoprint
            ? routes.webtoprint.path
            : (routes.showcaseprint ? routes.showcaseprint.path : '/print')

        const signagePath = isOn('signage') ? '/signage' : '/signage-lite'

        const tiles = [
            { key: 'programm', labelId: 'route_program', label: 'Programm', descId: 'dashboard_hex_desc_programm', iconKey: 'programm', onClick: () => this.nav(routes.program ? routes.program.path : '/program') },
            { key: 'advertisement', labelId: 'route_advertisement', label: 'Advertisement', descId: 'dashboard_hex_desc_advertisement', iconKey: 'advertisement', disabled: !isOn('advertisement'), onClick: () => this.nav(routes.advertisement ? routes.advertisement.path : '/advertisement') },
            { key: 'web2print', labelId: 'route_web2print', label: 'Web2Print', descId: 'dashboard_hex_desc_web2print', iconKey: 'web2print', onClick: () => this.nav(printPath) },
            { key: 'signage', labelId: 'route_signage', label: 'Signage', descId: 'dashboard_hex_desc_signage', iconKey: 'signage', disabled: !hasSignage, onClick: () => this.nav(signagePath) },
            { key: 'apps', labelId: 'route_apps', label: 'Apps', descId: 'dashboard_hex_desc_apps', iconKey: 'apps', disabled: !hasApps, onClick: () => this.nav('/apps') },
            { key: 'socialmedia', labelId: 'route_social_media', label: 'Social Media', descId: 'dashboard_hex_desc_socialmedia', iconKey: 'socialmedia', disabled: !hasSocialMedia, onClick: () => this.nav(routes.socialMedia ? routes.socialMedia.path : '/social-media') },
            { key: 'newsletter', labelId: 'route_newsletter', label: 'Newsletter', descId: 'dashboard_hex_desc_newsletter', iconKey: 'newsletter', disabled: !hasNewsletter, onClick: () => this.nav(routes.newsletter ? routes.newsletter.path : '/newsletter') },
            { key: 'events', labelId: 'route_events', label: 'Events', descId: 'dashboard_hex_desc_events', iconKey: 'events', disabled: !hasEvents, onClick: () => this.nav('/events') },
            { key: 'elbenwald', labelId: 'route_elbenwald', label: 'Elbenwald', descId: 'dashboard_hex_desc_elbenwald', iconKey: 'elbenwald', disabled: !hasElbenwald, onClick: () => this.nav(routes.elbenwald ? routes.elbenwald.path : '/elbenwald') },
            { key: 'chatbot', labelId: 'route_chatbot', label: 'Chatbot', descId: 'dashboard_hex_desc_chatbot', iconKey: 'chatbot', disabled: !hasChatbot, onClick: () => { window.location.href = '/wp-admin/admin.php?page=pmbot-settings' } },
            ...(showCinemas ? [{ key: 'cinemas', labelId: 'cinemas', label: 'Cinemas', descId: 'dashboard_hex_desc_cinemas', iconKey: 'cinemas', onClick: () => this.nav(routes.cinemas ? routes.cinemas.path : '/cinemas') }] : []),
        ]

        const rows = chunkIntoRows(tiles, cols)

        return (
            <div className="db-hex-section" ref={this.sectionRef} style={{ '--hex-w': hexW + 'px', '--hex-gap': HEX_GAP + 'px' }}>
                <div className="db-hc-grid">
                    {rows.map((row, rowIndex) => (
                        <div key={rowIndex} className={`db-hc-row${rowIndex % 2 === 1 ? ' db-hc-row--offset' : ''}`}>
                            {row.map((tile, tileIndex) => (
                                <HexTile
                                    {...tile}
                                    calloutDir={rowIndex % 2 === 0 ? 'down' : 'up'}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default DashboardHexMenu
